import { Switch } from "native-base"
import { useAPI } from "../../../../../Universal/API/API"
import { useAppContext } from "../../../../../Universal/API/Context-API/AppContext"
import React from "react"
const UserPriceSwitch = ({mode = 'default'}) => {

    const {handleToggleDiscountSwitch} = useAPI()

    const {showDiscountedPrices} = useAppContext()

    return(
        <Switch
                    isChecked={mode == 'default' ? showDiscountedPrices: !showDiscountedPrices}
                    onToggle={handleToggleDiscountSwitch}
                  />
    )
}

export default UserPriceSwitch